import { GameType } from "types/Games";
import { BonusFreeSpinResponseDataType } from "./User";
import { bonusTypeCurrency } from "./info";

export enum BONUS_STATUS {
  ACTIVE = "active",
  DEACTIVE = "deactive",
  QUEUE = "queue",
  AVAILABLE = "available",
  AVAILABLE_QUEUE = "available_queue",
  UNAVAILABLE = "unavailable",
}

export enum WAGER_TYPE {
  REAL = "real",
  ANY = "any",
}
export enum BONUS_TYPES {
  REWARD = "Reward",
  SPINS = "Spins",
  TRIGGER = "Trigger",
  NOMINAL = "Nominal",
  FREE_SPINS = "FreeSpins",
}
export enum BONUS_ITEM {
  TOTAL_SPINS = "leftSpins",
  REWARD = "reward",
  NOMINAL = "nominal",
  TRIGGER = "trigger",
  VALID = "valid",
  TIMER = "timer",
  FREE_SPINS = "freeSpins",
}

export enum FREE_SPINS_STAGES {
  AVAILABLE = "available", // Доступна к получению (Мотивированный триггер)
  QUEUE = "queue", // В очереди
  UNUSED = "unused", // Не прокручены совсем или прокручены частично фриспины
  USED = "used", // Прокручены все фриспины
}

export type BonusItem = {
  id: number;
  name: string;
  value: string;
};

export type BonusListType =
  | BonusMappedType
  | BonusNominalMappedType
  | BonusTriggerMappedType
  | BonusFreeSpinsMappedType;

export type BonusMappedType = {
  id: number;
  title: string;
  description: string;
  status: BONUS_STATUS;
  type: BONUS_TYPES;
  game?: GameType;
  minAmount?: number;
  totalSpins?: number; // Максимальное кол-во спинов
  leftSpins?: number; // Кол-во спинов, которые можно еще использовать
  wager: number; // Сколько ставок осталось сделать
  totalWager?: number; // бщее необходимое кол-во отыгрышей
  reward?: number;
  duration: number; // Время жизни бонуса
  startDate: string; // Дата активации бонуса
  startWagingDate?: string; // Дата активации wager
  endWagingDate?: string; // Дата окончания wager
  expireDate: string; // Дата деактивации бонуса
  progress: number;
  bonus?: bonusTypeCurrency;
  variant?: string;
  gameUrlAlias?: string;
};

export type BonusNominalMappedType = {
  amount: number;
  minAmount: number;
  currency: string;
  expireAt: string;
  id: string;
  name: string;
  gameName: string;
  status: BONUS_STATUS;
  wagerAmountRemain: number;
  wager: number;
  wagerType: WAGER_TYPE;
  wagerGameIds: string[];
  wagerProductNames: string[];
  wagerProviderNames: string[];
  textBeforeReceivingAward: string;
  textAfterReceivingAward: string;
  progress: number;
  type: BONUS_TYPES;
  gameUrlAlias?: string;
};

export type BonusFreeSpinsMappedType = BonusFreeSpinResponseDataType & {
  progress: number;
  type: BONUS_TYPES.FREE_SPINS;
  freeSpinStage: FREE_SPINS_STAGES;
  nameGameFreeSpin?: string;
  gameUrlAlias?: string;
};

export type BonusTriggerMappedType = {
  amount: number;
  currency: string;
  expireAt: string;
  // id: string;
  name: string;
  status: BONUS_STATUS;
  // wagerAmountRemain: number;
  wager: number;
  wagerType: WAGER_TYPE;
  wagerGameIds: string[];
  wagerProductNames: string[];
  wagerProviderNames: string[];
  textBeforeReceivingAward: string;
  textAfterReceivingAward: string;
  // progress: number;
  type: BONUS_TYPES;
  bonus?: bonusTypeCurrency;
  gameUrlAlias?: string;
};

export type TriggerFreeSpinMappedType = BonusTriggerMappedType & {
  freeSpinStage: FREE_SPINS_STAGES;
  freeSpinsCount: number;
  freeSpinsGame: string;
};
